import { yupResolver } from '@hookform/resolvers/yup';
import { Colors } from '@oy/uicore';
import { Alert, Spacer, Text, TextField } from '@oy/uidesktop';
import { useForm } from 'react-hook-form';
import { useFormHelper, useTranslate } from 'src/hooks';
import CountryCodeDropdown from 'src/pages/Auth/RegisterPage/components/CountryCodeDropddown/CountryCodeDropdown';
import { RegisterChildFormType, formSchema } from './formSchema';

export const RegisterChildStep = ({
  handleSubmitRegister,
  initialUsername,
}: {
  handleSubmitRegister: (params: RegisterChildFormType) => Promise<void>;
  initialUsername: string;
}) => {
  const { getTranslation } = useTranslate();
  const { getErrorMessage } = useFormHelper();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    // @ts-expect-error Only set initial username.
    values: {
      username: initialUsername,
      country_code: '+62',
    },
  });

  return (
    <div>
      <Alert
        title={getTranslation('multiEntity_register_userNotRegistered')}
        type="warning"
      />
      <Spacer vertical={Spacer.Size.L}>
        <Text textStyle={Text.Style.HeadingMd}>
          {getTranslation('multiEntity_register')}
        </Text>
      </Spacer>
      <form onSubmit={handleSubmit(handleSubmitRegister)} id="add_child">
        <TextField
          label={getTranslation('common_fullName').toUpperCase()}
          placeholder={getTranslation('userProfile_textField_fullname')}
          {...register('full_name')}
          errorMessage={getErrorMessage(errors.full_name?.message)}
        />
        <TextField
          label={getTranslation('common_brandName').toUpperCase()}
          placeholder={getTranslation(
            'businessProfile_textField_brandPlaceholder',
          )}
          {...register('brand_name')}
          errorMessage={getErrorMessage(errors.brand_name?.message)}
        />
        <TextField
          label={getTranslation('common_username').toUpperCase()}
          placeholder={getTranslation('common_form_inputUsername')}
          {...register('username')}
          errorMessage={getErrorMessage(errors.username?.message)}
        />
        <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK100}>
          {getTranslation(`common_phoneNumber`).toUpperCase()}
        </Text>
        <div style={{ display: 'flex' }}>
          <CountryCodeDropdown
            setField={(_key, value) => setValue('country_code', value)}
            value={watch('country_code') ?? ''}
          />
          <div style={{ flex: '1' }}>
            <TextField
              placeholder={getTranslation('userProfile_textField_phoneNumber')}
              {...register('phone_number')}
              type="number"
              errorMessage={getErrorMessage(errors.phone_number?.message)}
            />
          </div>
        </div>
        <Text textStyle={Text.Style.BodySmRegular}>
          {getTranslation('auth_register_phonenumberHelp')}
        </Text>
        <TextField
          label={getTranslation('common_email').toUpperCase()}
          placeholder={getTranslation('userProfile_textField_email')}
          helpText={getTranslation('multiEntity_register_emailHelpText')}
          {...register('email')}
          errorMessage={getErrorMessage(errors.email?.message)}
        />
      </form>
    </div>
  );
};
